import { useQuery } from 'react-query';
import axios from 'axios';

import { useAppSelector } from '@/app/hooks';
import { DomainOverview, DomainOverviewResponse } from '@/models/Domain';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';
import { AwsConfigApiGateway } from '@/utils/config/api';

import queryKeys from '../../modules/shared/query/queryKeys';

async function getDomainDetails(token: string | undefined, workspaceId: string, domainName: string) {
  const response = await axios.get<DomainOverviewResponse>(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/workspaces/${workspaceId}/domains/${domainName}`,
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data.data;
}

export function useGetDomainDetails(domainName: string) {
  const { user } = useAuth();
  const workspace = useAppSelector(selectCurrentWorkspace);
  return useQuery<DomainOverview>({
    queryKey: [queryKeys.domainDetails + domainName],
    queryFn: () => getDomainDetails(user?.signInUserSession.idToken.jwtToken, workspace?.id ?? '', domainName),
  });
}
